import type { TranslationDict } from "./en";

export const fr: TranslationDict = {
  lang: "fr" as const,
  langLabel: "FR",
  langFull: "Français",
  switchTo: "English",

  nav: {
    flightDeck: "Poste de Pilotage",
    requestTakeoff: "Demander le Décollage",
    scenarioTraining: "Entraînement par Scénarios",
    turbulenceZones: "Zones de Turbulence",
    flightLogbook: "Carnet de Vol",
    tower: "Tour de Contrôle",
    adminPanel: "Panneau Admin",
    questionBank: "Banque de Questions",
    questionReview: "Révision des questions",
    aiScenarios: "Entraînement par scénarios",
    supportTickets: "Tickets de Support",
    modTeam: "Équipe Mod",
    settings: "Paramètres",
    signOut: "Déconnexion",
    signOutInstead: "Se déconnecter",
    openMenu: "Ouvrir le menu",
    openNav: "Ouvrir le menu de navigation",
    utcTime: "Heure UTC",
    utcTimeShort: "UTC",
    localTime: "Heure locale",
    localTimeShort: "Local",
    utcClockTitle:
      "Temps universel coordonné (UTC). Équivalent à l'heure Zulu dans les NOTAM, la météo et les plans de vol.",
    localClockTitle: "Fuseau horaire local de votre appareil.",
    cadorsDaily: "CADORS quotidien",
  },

  twoFa: {
    title: "VÉRIFICATION EN 2 ÉTAPES REQUISE",
    body: "Les comptes administrateur et modérateur doivent activer l'authentification à deux facteurs. Vous devez la configurer avant d'accéder aux fonctionnalités.",
    cta: "CONFIGURER LA 2FA MAINTENANT",
  },

  signup: {
    readyToFly: "Prêt à Voler",
    title: "POSTE DE PILOTAGE",
    subtitle: "PRÉPARATION À L'EXAMEN",
    tagline: "Créez votre compte en quelques secondes. Vous pourrez compléter votre profil d'aviateur plus tard dans les Paramètres.",
    fullName: "NOM COMPLET",
    email: "COURRIEL",
    password: "MOT DE PASSE",
    confirmPassword: "CONFIRMER LE MOT DE PASSE",
    showPassword: "Afficher le mot de passe",
    hidePassword: "Masquer le mot de passe",
    passwordMismatch: "Les mots de passe ne correspondent pas",
    legalTitle: "CONDITIONS, CONFIDENTIALITÉ & DÉCHARGE",
    legalAgreement: "FLIGHT DECK CPL EXAM PREP — ACCORD LÉGAL",
    legalIntro:
      "Veuillez lire le résumé suivant avant de créer votre compte. Les versions complètes de chaque document sont disponibles aux liens ci-dessous. En cochant la case, vous confirmez avoir lu, compris et accepté l'ensemble des conditions. Date d'entrée en vigueur : 2 avril 2026 · Droit applicable : Province de l'Ontario, Canada.",
    tosTitle: "CONDITIONS D'UTILISATION",
    tos1: "En vous inscrivant, vous acceptez d'utiliser ce Service uniquement à des fins personnelles et non commerciales de préparation à l'examen. Vous devez avoir au moins 16 ans. L'accès au compte est soumis à l'approbation de l'administrateur et peut être révoqué à tout moment.",
    tos2: "Vous acceptez de ne pas partager, revendre ou distribuer l'accès ou le contenu ; de ne pas copier ou extraire la banque de questions ; de ne pas publier de contenu illégal, harcelant ou diffamatoire ; et de ne pas tenter de compromettre la sécurité de la plateforme.",
    tos3: "Tout le contenu — y compris les questions, les explications et le design — est la propriété de Flight Deck CPL Exam Prep et est protégé par le droit d'auteur canadien. Vous recevez une licence limitée, non transférable et révocable à des fins d'étude personnelle uniquement.",
    tos4: "Le Service est fourni « tel quel ». Nous nous réservons le droit de modifier ou d'interrompre toute fonctionnalité à tout moment. Nous pouvons mettre à jour ces Conditions à tout moment ; la poursuite de l'utilisation vaut acceptation. Les litiges relèvent de la compétence exclusive des tribunaux de la Province de l'Ontario.",
    privacyTitle: "POLITIQUE DE CONFIDENTIALITÉ (LPRPDE)",
    privacy1: "Nous collectons les informations minimales nécessaires au fonctionnement de ce Service : votre nom, votre adresse courriel et (optionnellement) votre province, date de naissance, genre, type de licence de pilote et qualifications détenues. Nous enregistrons également vos données de performance d'étude.",
    privacy2: "Nous ne vendons, ne louons ni n'échangeons vos informations personnelles. Nous n'utilisons pas de traceurs publicitaires ni d'analyses tierces. Les mots de passe sont stockés sous forme de hachages Argon2id sécurisés — nous n'avons jamais accès à votre mot de passe en texte clair. Toutes les données sont transmises via le chiffrement TLS.",
    privacy3: "Nous conservons vos données tant que votre compte est actif. Vous pouvez demander l'accès, la correction ou la suppression de vos informations personnelles à tout moment via notre",
    privacy3b: "formulaire d'assistance",
    privacy3c: ". Les demandes de suppression sont traitées dans les 30 jours.",
    privacy4: "En vertu de la LPRPDE, vous avez le droit d'accéder à vos données, de corriger les inexactitudes, de retirer votre consentement et de déposer une plainte auprès du Commissariat à la protection de la vie privée du Canada (priv.gc.ca) si vous estimez que vos informations ont été mal gérées.",
    waiverTitle: "AVIS DE NON-RESPONSABILITÉ & DÉCHARGE DE RESPONSABILITÉ",
    waiver1: "Flight Deck CPL Exam Prep est un outil d'étude indépendant. Il n'est pas affilié à Transports Canada, au gouvernement du Canada ou à toute autorité réglementaire de l'aviation, et n'est pas approuvé par ces derniers.",
    waiver2: "Les questions d'entraînement sont créées de manière indépendante et ne constituent pas du contenu officiel d'examen de Transports Canada. Nous n'accordons aucune garantie — expresse ou implicite — que le contenu est exact, à jour, complet ou conforme au Règlement de l'aviation canadien (RAC) actuel. Le contenu peut ne pas refléter les mises à jour réglementaires les plus récentes.",
    waiver3: "Vous assumez expressément tous les risques associés à l'utilisation de cette plateforme, y compris le risque que les questions contiennent des erreurs, que l'utilisation de cette plateforme ne vous prépare pas à l'examen officiel et le risque d'échec à un examen officiel. Vous restez seul responsable de la consultation des publications officielles actuelles de Transports Canada et de la recherche d'une instruction professionnelle qualifiée dans le cadre de votre préparation.",
    waiver4: "Dans toute la mesure permise par la loi canadienne, vous libérez, renoncez et dégagez Flight Deck CPL Exam Prep et ses opérateurs de toute réclamation découlant de votre utilisation du Service, y compris l'échec à l'examen, le contenu inexact, la perte de frais d'examen ou la perte d'opportunité de carrière.",
    waiver5: "Rien dans cette Décharge ne limite la responsabilité pour négligence grave, faute intentionnelle, fraude ou tout autre élément qui ne peut pas être légalement exclu en vertu du droit canadien. Cette Décharge est régie par les lois de la Province de l'Ontario.",
    fullDocs: "Documents complets :",
    termsLink: "Conditions d'utilisation",
    privacyLink: "Politique de confidentialité",
    waiverLink: "Décharge de responsabilité",
    scrollHint: "défiler pour tout lire ↑",
    agreeCheckbox: "J'ai lu et j'accepte les Conditions d'utilisation, la Politique de confidentialité et la Décharge de responsabilité ci-dessus. Je comprends que cette plateforme n'est pas affiliée à Transports Canada, n'offre aucune garantie quant à l'exactitude du contenu et que je l'utilise entièrement à mes propres risques.",
    submitting: "ENVOI EN COURS...",
    createAccount: "CRÉER UN COMPTE",
    successTitle: "DEMANDE SOUMISE",
    successBody: "Votre demande de compte a été reçue. Vous pourrez vous connecter une fois que l'administrateur aura approuvé votre compte.",
    backToLogin: "RETOUR À LA CONNEXION",
    alreadyHaveAccess: "Vous avez déjà accès ?",
    signIn: "Se connecter",
    registrationFailed: "Échec de l'inscription",
    passwordRequirements: "Le mot de passe ne satisfait pas toutes les exigences",
    orDivider: "ou",
    googleLegalHint: "Acceptez l'accord ci-dessus pour utiliser l'inscription Google.",
    googleOAuthFallback: "S'inscrire avec Google (redirection navigateur)",
  },

  dashboard: {
    title: "Vue d'ensemble du Vol",
    subtitle: "Suivez votre conscience situationnelle avant l'approche finale.",
    tackleturb: "Affronter les Turbulences",
    openSessionHistory: "Historique des sessions",
    openSessionHistoryPanelCta: "Ouvrir le panneau d'historique",
    sessionHistoryMobileHint: "Consultez les sessions terminées et le détail des réponses dans un panneau latéral.",
    collapsibleProgressTitle: "Jalons de progression",
    collapsibleProgressSub: "Touchez pour afficher ou masquer les jalons sur cette page.",
    openLeaderboard: "Classement",
    requestTakeoff: "Demander le Décollage",
    freePlanTitle: "Plan Gratuit — section CG uniquement, max 20 questions/session",
    freePlanSub: "Pro Plus Avancé (24,99 $ CA) est la solution complète de préparation à l'examen — plus de 5 000 questions, simulations style CPAER, entraînement aux faiblesses et Score de préparation à l'examen avec prédiction de réussite.",
    proPlanTitle: "Plan Pro — pratique seulement, ~400 questions",
    proPlanSub: "Votre plan actuel est insuffisant pour une préparation complète à l'examen. Passez au Pro Plus Avancé (24,99 $ CA) pour la banque complète de plus de 5 000 questions, examens chronométrés style CPAER, entraînement aux faiblesses et votre Score de préparation à l'examen.",
    viewPlans: "Voir les plans",
    passYourExam: "Réussir votre examen",
    waypointsCleared: "Points de Passage Franchis",
    accuracy: "Précision",
    flightsLogged: "Vols Enregistrés",
    currentStreak: "Série Actuelle",
    days: "jours",
    groundStatus: "État au Sol",
    groundStatusSub: "Inventaire du hangar",
    hangarCapacity: "Capacité du Hangar",
    dispatchStatus: "État d'Expédition",
    clearedToFly: "AUTORISÉ À VOLER",
    grounded: "CLOUÉ AU SOL",
    goToImport: "Aller à l'Importation",
    sectorMap: "Carte des Secteurs",
    sectorMapSub: "Analyse radar — précision et couverture dans chaque domaine de l'examen.",
    proPlus: "PRO PLUS AVANCÉ",
    avgAccuracy: "Précision Moy.",
    bankCoverage: "Couverture de la Banque",
    sectorsScanned: "Secteurs Analysés",
    strongestSector: "Secteur le Plus Fort",
    weakestSector: "Secteur le Plus Faible",
    deepRadarTitle: "Analyse Radar Approfondie",
    deepRadarBadge: "FONCTIONNALITÉ PRO PLUS AVANCÉ",
    deepRadarBody: "La précision par secteur, la couverture de la banque, la puissance du signal et la notation de performance dans tous les domaines de l'examen sont exclusives au Pro Plus Avancé.",
    deepRadarProNote: "Votre plan Pro couvre la progression globale. Passez au niveau supérieur pour déverrouiller la vue complète du renseignement sectoriel.",
    upgradeBtn: "Passer au Pro Plus Avancé",
    upgradePrice: "19,99 $ CA / mois · Annulez en tout temps",
    coverageLabel: "COUVERTURE",
    accuracyLabel: "PRÉCISION",
    remainingLabel: "restantes",
    noDataTitle: "RADAR HORS LIGNE",
    noDataBody: "Aucune donnée de vol enregistrée. Complétez votre première session pour commencer le suivi.",
    startFirstSession: "Commencer la Première Session",
    examReadiness: "Préparation à l'Examen",
    examReadinessSub: "Taux de réussite projeté basé sur les performances d'entraînement.",
    examReadinessLocked: "Le Score de préparation à l'examen est une fonctionnalité Pro Plus Avancé.",
    examReadinessNote: "Nécessite au moins 100 questions répondues par catégorie.",
    unlockExam: "Débloquer la Préparation à l'Examen",
    statusCleared: "DÉGAGÉ",
    statusOnCourse: "EN ROUTE",
    statusMarginal: "MARGINAL",
    statusTurbulence: "TURBULENCE",
    statusCritical: "CRITIQUE",
    statusUncharted: "INEXPLORÉ",
    attemptedLabel: "Essayées",
    correctLabel: "Correct",
    inBankLabel: "Dans la banque",
    signalLabel: "SIGNAL",
    accuracyWord: "précision",
    qNotYetAttempted: "{n} question pas encore essayée",
    qNotYetAttemptedPlural: "{n} questions pas encore essayées",
    waypointsClearedNote: "Nombre total de questions auxquelles vous avez répondu dans les sessions de ce parcours.",
    accuracyNote: "Pourcentage global de bonnes réponses dans ce parcours : bonnes réponses divisées par questions répondues.",
    flightsLoggedNote: "Nombre total de sessions terminées dans ce parcours.",
    currentStreakNote: "Nombre de jours consécutifs avec au moins une session terminée dans ce parcours.",
  },

  practice: {
    title: "Briefing Pré-Vol",
    subtitle: "Configurez votre session d'entraînement avant le départ.",
    sessionMode: "MODE DE SESSION",
    questionCount: "NOMBRE DE QUESTIONS",
    categoryFocus: "FOCUS CATÉGORIE",
    selectCategory: "Sélectionner une catégorie",
    modeRandom: "Mélange Aléatoire",
    modeRandomDesc: "Questions de toutes les catégories dans un ordre aléatoire",
    modeCategory: "Focus Catégorie",
    modeCategoryDesc: "Approfondissement d'un domaine d'examen spécifique",
    modeWeakness: "Entraînement aux faiblesses",
    modeWeaknessDesc: "Concentrez-vous sur vos domaines les plus faibles",
    modeExam: "Simulation d'Examen",
    modeExamDesc: "Examen chronométré complet style CPAER",
    modeLadder: "Grimper l'échelle",
    modeLadderDesc: "Une matière : questions plus faciles d'abord, puis plus difficiles",
    modeLadderFormatNote:
      "Choisissez une matière ci-dessous, puis le nombre de questions. Ce mode sert au rythme d'apprentissage — ce n'est pas un examen noté.",
    modeLadderPanelTitle: "COMMENT FONCTIONNE GRIMPER L'ÉCHELLE",
    modeLadderPanelBody1:
      "Toutes les questions viennent de la matière choisie. La session les classe par difficulté : d'abord les plus faciles, puis moyennes, puis les plus difficiles. Vous vous échauffez avant les sujets les plus durs. Si une question n'a pas de niveau de difficulté dans la banque, elle est traitée comme moyenne.",
    modeLadderPanelBody2:
      "À l'intérieur de chaque niveau, l'ordre est mélangé pour que chaque session ne soit pas identique. Avec Pro et Pro Plus, la banque peut privilégier les questions non vues tout en conservant l'ordre facile → moyen → difficile.",
    modeScenario: "Entraînement par Scénarios",
    modeScenarioDesc: "Scénarios de vol de style examen à sujets multiples",
    missionParams: "Paramètres de Mission",
    missionParamsDesc: "Sélectionnez votre cap et charge de carburant avant de démarrer les moteurs.",
    trainingMode: "Mode d'Entraînement",
    selectSubject: "Sélectionner une Matière",
    selectSubjectPlaceholder: "Choisir une catégorie",
    commenceSession: "Commencer la Session",
    enterScenario: "Entrer dans le Scénario",
    proceedToBriefing: "Procéder au Briefing",
    examLocked: "Examen Verrouillé",
    initializing: "Initialisation...",
    examBriefingBody: "Vous êtes sur le point de commencer une simulation complète de l'examen CPL écrit. Cela comprend {questions} questions avec une limite de temps de {hours} heure(s). Aucun retour sur les réponses n'est donné pendant l'examen — les résultats sont affichés à la fin.",
    beginExamination: "Commencer l'Examen",
    cancel: "Annuler",
    requestTakeoff: "DEMANDER LE DÉCOLLAGE",
    loadingCategories: "Chargement des catégories...",
    categoryRequired: "Catégorie Requise",
    categoryRequiredDesc: "Veuillez sélectionner une catégorie pour commencer.",
    examBriefingTitle: "BRIEFING D'EXAMEN",
    examBriefingClosed: "BRIEFING D'EXAMEN — FERMÉ",
    examCriteria: "CRITÈRES D'EXAMEN CPAIR",
    ready: "PRÊT",
    notReady: "PAS PRÊT",
    noScenarios: "Aucune question de scénario n'est disponible pour l'instant. Revenez bientôt.",
    proRequired: "Pro Plus Avancé requis",
    noScenarioTitle: "Aucune Question de Scénario Disponible",
    noScenarioDesc: "Aucune question de scénario n'a encore été publiée. Revenez bientôt.",
    sessionFailTitle: "Échec du démarrage de la session",
    sessionFailDesc: "Assurez-vous d'avoir suffisamment de questions dans la banque.",
    aiScenarioLabel: "ENTRAÎNEMENT PAR SCÉNARIOS",
    aiScenarioDesc: "Questions de scénario CPL canadiennes sélectionnées et révisées par l'équipe, qui combinent plusieurs sujets comme à l'examen. Chaque élément comprend une explication complète et un raccourci pratique.",
    scenarioBullet1: "Navigation et triangle des vents",
    scenarioBullet2: "Calculs de consommation de carburant",
    scenarioBullet3: "Navigation à l'estime et vitesse sol",
    scenarioBullet4: "RAC appliqué en vol",
    scenarioBullet5: "Problèmes temps-vitesse-distance",
    scenarioBullet6: "Angles de correction de dérive",
    scenarioCPAERNote: "Questions de style CPAER — légèrement complexes, nécessitent réflexion, pas seulement mémorisation.",
    examFormatNote: "Format officiel d'examen de Transports Canada — questions mixtes de toutes les matières. Aucun retour sur les réponses pendant l'examen.",
    examQuestionsLabel: "Questions",
    examTimeLimitLabel: "Limite de Temps",
    examPassMarkLabel: "Note de Passage",
    sectionReadiness: "Préparation par Section",
    minCorrectEach: "Min. {n} correctes chacune",
    correctLabel: "correct",
    allSectionsReady: "Toutes les sections prêtes",
    sectionsNeedPractice: "{n} section{s} nécessite{s2} plus de pratique",
    questionCountLabel: "Nombre de Questions",
    selectCount: "Sélectionner le nombre",
    examUnlockedLabel: "✓ EXAMEN DÉVERROUILLÉ",
    examLockedLabel: "🔒 VERROUILLÉ",
    freePlanNote: "Plan gratuit : max 40 questions par section, non-rotatif.",
    upgradeForMore: "Passez à un plan supérieur pour plus.",
    examModalTitle: "EXAMEN VERROUILLÉ",
    examModalSubtitle: "Complétez les exigences de pratique pour déverrouiller",
    examModalBody: "Répondez correctement à au moins {n} questions dans chaque section avant de passer l'examen.",
    moreCorrectNeeded: "réponses correctes manquantes",
    correctlyAnsweredCount: "répondu correctement",
    close: "Fermer",
  },

  session: {
    question: "Question",
    of: "sur",
    correct: "Correct",
    incorrect: "Incorrect",
    next: "Question Suivante",
    finish: "Terminer la Session",
    explanation: "Explication",
    ruleOfThumb: "Règle Pratique",
    source: "Source",
    bookmark: "Marquer",
    bookmarked: "Marqué",
    reveal: "Révéler la Réponse",
    scenarioContext: "Contexte du Scénario",
    examTitle: "EXAMEN ÉCRIT CPL",
    noFeedback: "SANS RÉTROACTION",
    waypoints: "jalons",
    skippedBadge: "IGNORÉ",
    skippedCount: "ignoré(s)",
    abort: "ABANDONNER",
    abortTitle: "ABANDONNER LA MISSION?",
    abortBodyAnswered: "Vous avez répondu à {n} sur {total} questions. Votre progression sera sauvegardée.",
    abortBodyNone: "Vous n'avez pas encore répondu à une seule question. La session sera enregistrée avec 0 réponses.",
    continueSession: "CONTINUER LA SESSION",
    confirmAbort: "CONFIRMER L'ABANDON",
    save: "SAUVER",
    saved: "SAUVÉ",
    skipAnswerLater: "IGNORER — RÉPONDRE PLUS TARD",
    submitting: "SOUMISSION...",
    submitFinishExam: "SOUMETTRE ET TERMINER L'EXAMEN",
    submitAnswer: "SOUMETTRE LA RÉPONSE",
    confirmAnswer: "CONFIRMER LA RÉPONSE",
    completeSession: "TERMINER LA SESSION",
    nextWaypoint: "JALON SUIVANT",
    affirmative: "AFFIRMATIF",
    negative: "NÉGATIF",
    filingFlightPlan: "DÉPÔT DU PLAN DE VOL...",
    backToBriefing: "Retour à la Salle de Briefing",
    noQuestions: "ERR : AUCUNE QUESTION DANS LA SESSION",
    flagQuestion: "Signaler",
    flagTitle: "SIGNALER CETTE QUESTION",
    flagDesc: "Vous avez trouvé une erreur, une ambiguïté ou un contenu désuet ? Faites-le nous savoir — ce bouton envoie un rapport à notre équipe, ce n'est pas un bouton de sauvegarde.",
    flagNotePlaceholder: "Décrivez le problème (5 mots minimum)...",
    flagSubmit: "ENVOYER LE SIGNALEMENT",
    flagSubmitting: "ENVOI EN COURS...",
    flagSuccess: "Signalement envoyé",
    flagSuccessDesc: "Notre équipe examinera cette question.",
    flagError: "Échec de l'envoi du signalement",
    flagMinWords: "Veuillez décrire le problème en au moins 5 mots.",
    flagAlready: "Déjà signalé",
  },

  weaknesses: {
    title: "Zones de Turbulence",
    subtitle: "Vos questions les plus difficiles — exercez-vous jusqu'à les maîtriser.",
    tabWeakness: "Questions Faibles",
    tabSaved: "Questions Sauvegardées",
    drillAll: "Exercer toutes les Questions Faibles",
    flyIntoTurbulence: "Entrez dans la Turbulence",
    drillSingle: "Exercer",
    noWeaknessTitle: "TOUT EST CLAIR",
    noWeaknessBody: "Aucune question faible détectée. Continuez à voler — les faiblesses apparaîtront ici une fois que vous aurez répondu incorrectement à au moins 3 questions.",
    noSavedTitle: "AUCUNE QUESTION SAUVEGARDÉE",
    noSavedBody: "Marquez des questions pendant une session pour les revoir ici.",
    removeSaved: "Supprimer",
    attempts: "tentatives",
    accuracy: "précision",
    missed: "fois manquée",
    proRequired: "Pro Plus Avancé Requis",
    proRequiredBody: "Les Zones de Turbulence sont une fonctionnalité Pro Plus Avancé. Passez au niveau supérieur pour débloquer l'entraînement ciblé sur les faiblesses.",
    upgradeBtn: "Passer au Pro Plus Avancé",
    noSavedToastTitle: "Aucune Question Sauvegardée",
    noSavedToastDesc: "Marquez des questions pendant une session d'entraînement d'abord.",
    bookmarkRemovedTitle: "Signet supprimé",
    bookmarkRemovedDesc: "Question retirée de votre liste sauvegardée.",
    clearOneMore: "Encore 1 correcte pour dégager la zone",
    clearTwoMore: "Répondre correctement 2× pour dégager",
    flyThis: "Voler Cette Question",
    clearSkiesTitle: "Ciel Dégagé",
    clearSkiesBody: "Aucune turbulence détectée pour l'instant. Continuez à voler plus de missions pour identifier les secteurs qui nécessitent du travail.",
    starting: "Démarrage...",
    drillAllN: "Exercer tous les {n}",
    drillNSaved: "Exercer {n} sauvegardées",
    bookmarksNote: "Les signets sont stockés sur cet appareil. Compléter une session ne les supprime pas — retirez-les individuellement ci-dessous ou dans une session.",
    bookmarkedDuring: "Marqué pendant l'entraînement",
    savedEmptyTitle: "Aucune Question Sauvegardée",
    savedEmptyBody: "Marquez des questions pendant les sessions d'entraînement et exercez-les comme un ensemble ciblé.",
    bookmarksPersistNote: "Les signets sont stockés sur cet appareil et persistent entre les sessions jusqu'à ce que vous les supprimiez.",
    pausedTitle: "Compte Suspendu",
    pausedBody: "Les Zones de Turbulence ne sont pas accessibles tant que votre compte est suspendu.",
    pausedResumesOn: "Votre compte reprendra automatiquement le {date}.",
    pausedSafe: "Votre progression est en sécurité. Toutes les autres sections de Flight Deck restent accessibles.",
    errorRateLabel: "Taux d'Erreur",
    wrongLabel: "Erreurs",
    totalCountLabel: "Total",
    masteryLabel: "Maîtrise",
    weaknessLockTitle: "Entraînement aux Faiblesses",
    weaknessLockBadge: "FONCTIONNALITÉ PRO PLUS AVANCÉ",
    weaknessLockBody: "Le suivi des faiblesses identifie les questions que vous manquez le plus souvent et vous permet de les réviser directement — la façon la plus efficace de combler vos lacunes avant l'examen.",
    weaknessProNote: "Votre plan Pro actuel n'inclut pas le suivi des faiblesses. Passez au Pro Plus pour le débloquer.",
    savedLockTitle: "Questions Sauvegardées",
    savedLockBadge: "FONCTIONNALITÉ PRO",
    savedLockBody: "Marquez des questions pendant les sessions d'entraînement et exercez-les comme un ensemble ciblé. Disponible sur le plan Pro et supérieur.",
    upgradeToPro: "Passer au Pro",
  },

  cadors: {
    pageTitle: "CADORS — cas du jour",
    pageSubtitle:
      "Consultez les récits d'événements pour la date de rapport sélectionnée (Transports Canada). Les données proviennent du rapport national CADORS officiel.",
    tabCases: "Cas",
    tabAbout: "Source et avertissement",
    dateWindowHint:
      "Les dates sont des jours civils UTC. Vous ne pouvez choisir qu'entre il y a un mois et aujourd'hui — pas de date future.",
    reportingDateLabel: "Date de rapport (jour civil UTC)",
    dateFromLabel: "Du (UTC)",
    dateToLabel: "Au (UTC)",
    accidentsDateRangeIntro:
      "Choisissez un seul jour (même date du et au) ou une plage (ex. du 8 au 12). Seuls les accidents sont renvoyés ; les autres types sont exclus.",
    rangeSummary: "Dates de rapport (UTC) : {from} → {to}",
    reportingDateLabelShort: "Date de rapport SCREAQ",
    rangeInvalidTitle: "Plage de dates invalide",
    rangeInvalidDesc:
      "« Au » doit être le même jour ou après « Du », et les deux dates doivent rester dans la fenêtre autorisée.",
    load: "Charger le rapport",
    loading: "Téléchargement depuis Transports Canada…",
    emptyTitle: "Aucun cas ce jour-là",
    emptyBody:
      "Aucun contenu pour cette date de rapport, ou le rapport ne comportait pas de blocs d'événement. Essayez une autre date ou ouvrez le rapport officiel dans un nouvel onglet.",
    errorDisabled: "L'étude CADORS n'est pas activée (variable serveur CADORS_FEATURE ou VITE_ENABLE_CADORS).",
    errorGeneric: "Impossible de charger le rapport CADORS depuis l'application. Réessayez plus tard ou utilisez le site officiel de Transports Canada.",
    openOfficial: "Ouvrir le rapport officiel",
    categoriesLabel: "Catégories",
    typeLabel: "Type d'événement",
    filterLabel: "Afficher",
    filterAll: "Tous les types",
    filterAccidents: "Accidents seulement",
    filterAccidentsHelp:
      "Selon le champ « type d'événement » de Transports Canada : seuls les enregistrements libellés « Accident » sont inclus (pas les incidents, incidents graves ni autres types).",
    disclaimer:
      "Les renseignements du SCREAQ sont préliminaires et peuvent changer. Le Bureau de la sécurité des transports du Canada est la source officielle des données sur les accidents et incidents aéronautiques. Cet écran résume uniquement les récits publics du SCREAQ et ne remplace pas le matériel d'enquête officiel.",
    truncated:
      "{shown} affichés sur {total} correspondant à ce filtre (plafond {max} par requête). Ouvrez le rapport complet sur le site de Transports Canada pour le reste.",
    occurrenceCount: "{n} cas affichés ci-dessous",
    matchLine: "{shown} affichés · {total} correspondent à ce filtre",
    emptyAccidentsTitle: "Aucun accident dans cet extrait",
    emptyAccidentsBody:
      "Il peut tout de même y avoir des incidents et d'autres types d'événement à cette date. Passez à « Tous les types », choisissez une autre date ou ouvrez le rapport officiel complet.",
  },

  analytics: {
    title: "Carnet de Vol",
    subtitle: "Votre historique d'entraînement complet et vos métriques de performance.",
    currentStreak: "Série Actuelle",
    longestStreak: "Plus Longue Série",
    totalStudyDays: "Jours d'Étude",
    sessionsCompleted: "Sessions",
    passRate: "Taux de Réussite",
    avgPerSession: "Moy. / Session",
    activityHeatmap: "Carte de Chaleur d'Activité",
    accuracyTrend: "Tendance de Précision",
    sessionBreakdown: "Répartition des Sessions",
    byCategory: "Par Catégorie",
    recentSessions: "Sessions Récentes",
    noData: "Aucune donnée. Complétez votre première session pour commencer le suivi.",
    proRequired: "Pro Plus Avancé Requis",
    proRequiredBody: "Les analyses complètes du carnet de vol sont une fonctionnalité Pro Plus Avancé.",
    upgradeBtn: "Passer au Pro Plus Avancé",
    days: "jours",
    day: "jour",
    modePractice: "Pratique",
    modeExamSim: "Sim. Examen",
    modeWeakness: "Faiblesses",
    modeCategory: "Catégorie",
    consecutiveDays: "jours consécutifs",
    personalBest: "record personnel",
    totalDaysActive: "jours actifs au total",
    sessionsDone: "sessions terminées",
    activityTitle: "ACTIVITÉ 30 JOURS",
    sessionModesTitle: "MODES DE SESSION",
    accuracyTrendTitle: "TENDANCE DE PRÉCISION",
    lastSessions: "20 dernières sessions",
    categoryAccTitle: "PRÉCISION PAR CATÉGORIE",
    noActivityYet: "Aucune activité pour l'instant.",
    noSessionsYet: "Aucune session pour l'instant.",
    lockedCurrentStreak: "Série Actuelle",
    lockedLongestStreak: "Plus Longue Série",
    lockedStudyDays: "Jours d'Étude",
    lockedPassRate: "Taux de Réussite",
    lockedAvgQ: "Moy. Q/Session",
    lockedCompleted: "Terminées",
    todayLabel: "aujourd'hui",
    answeredLabel: "répondues",
    recentSessionsTitle: "SESSIONS RÉCENTES",
    tableDate: "Date",
    tableMode: "Mode",
    tableTrack: "Parcours",
    tableCategory: "Catégorie",
    tableQuestions: "Questions",
    tableAccuracy: "Précision",
    noAnswersYet: "Aucune réponse enregistrée.",
    noSessionsCompleted: "Aucune session complétée.",
    unlockAnalytics: "Débloquer l'Analytique Avancée",
    unlockAnalyticsDesc: "Passez au Pro Plus Avancé pour les tendances de sessions, la carte thermique d'activité, la précision par catégorie et plus encore.",
    activityToday: "Aujourd'hui",
    activityLess: "Moins",
    activityMore: "Plus",
    lockedTitle: "PRO PLUS AVANCÉ",
    lockedBody: "Les analyses détaillées font partie du plan Pro Plus Avancé (24,99 $ CA/mois). Passez au niveau supérieur pour débloquer les tendances, la carte d'activité, la précision par catégorie et plus.",
    upgradeNow: "Mettre à Niveau",
    noSessionsChart: "Aucune session pour l'instant.",
    currentStreakNote: "Nombre actuel de jours consécutifs avec au moins une session terminée.",
    longestStreakNote: "Votre meilleure série consécutive de jours d'étude.",
    totalStudyDaysNote: "Nombre total de jours calendaires uniques où vous avez terminé au moins une session.",
    passRateNote: "Pourcentage de sessions terminées avec au moins 70 % de précision.",
    avgPerSessionNote: "Nombre moyen de questions répondues par session terminée.",
    sessionsCompletedNote: "Nombre total de sessions que vous avez entièrement terminées.",
  },

  sessionHistory: {
    title: "Révision des sessions",
    subtitle: "Chaque test terminé en un coup d'œil — totaux, erreurs et questions sans réponse — avec un raccourci vers le débriefing.",
    infoHint: "Les totaux proviennent de vos réponses enregistrées. « Sans réponse » désigne les questions de la session pour lesquelles aucune réponse n'a été envoyée avant la fin.",
    shuffle: "Ordre aléatoire",
    summaryTitle: "Toutes les sessions affichées",
    colAll: "Toutes",
    colUnanswered: "Sans réponse",
    colIncorrect: "Incorrectes",
    colCorrect: "Correctes",
    reviewCta: "Réviser",
    accuracyShort: "justesse",
    trackLabel: "Parcours",
    allCategories: "Toutes catégories",
    empty: "Aucune session terminée pour le moment. Terminez une session de pratique ou d'examen pour constituer votre historique ici.",
    goPractice: "Aller à la pratique",
    loadError: "Impossible de charger l'historique des sessions.",
    modeRandom: "Mélange aléatoire",
    modeCategory: "Catégorie",
    modeWeakness: "Faiblesses",
    modeExam: "Simul. examen",
    modeScenario: "Scénario",
  },

  leaderboard: {
    title: "Classement des pilotes",
    subtitle: "Les pilotes sont classés selon leurs résultats sur la période choisie—bonnes réponses, erreurs et justesse sur cette filière. Seuls les pseudonymes sont affichés.",
    metricHelp: "Fenêtres glissantes (UTC) : 7 jours, 30 jours ou tout le temps. Seuls les pilotes avec un pseudo et ayant accepté d’apparaître sont listés.",
    sortHint: "Les meilleurs rangs favorisent une bonne justesse avec un nombre solide de bonnes réponses—pas celui qui a répondu au plus de questions. Même logique pour chaque fenêtre.",
    tabWeek: "7 jours",
    tabMonth: "30 jours",
    tabAll: "Tout",
    podiumTitle: "Podium",
    podium1st: "1er",
    podium2nd: "2e",
    podium3rd: "3e",
    fullStandings: "Classement complet",
    colRank: "#",
    colPilot: "Pilote",
    colRankScore: "Score",
    colCorrect: "✓",
    colWrong: "✗",
    colScore: "Correctes",
    colAttempts: "Tentatives",
    colAccuracy: "Just.",
    you: "vous",
    yourRank: "Votre position",
    correctLabel: "bonnes réponses",
    wrongLabel: "mauvaises",
    attemptsLabel: "tentatives",
    accuracyLabel: "justesse",
    notRanked: "Vous n’êtes pas encore classé — définissez un pseudo, restez visible dans le classement et répondez aux questions.",
    empty: "Pas encore de classement pour cette période. Soyez le premier au tableau.",
    loadError: "Impossible de charger le classement.",
    retry: "Réessayer",
  },

  milestones: {
    title: "Jalons de progression",
    mobileOpenHint: "Toucher pour ouvrir les détails",
    subtitle:
      "Les objectifs sont calculés à partir de vos vraies sessions et réponses sur cette filière — pas de pop-ups ni de gamification bruyante. Revenez au fil des études ; les barres se mettent à jour automatiquement.",
    unlockedSummary: "{n} sur {total} débloqués",
    badgeStrip: "Badges de reconnaissance",
    done: "OK",
    loadError: "Impossible de charger les jalons. Vos données d’étude sont intactes — essayez d’actualiser.",
    footer:
      "Astuce : des sessions courtes et régulières battent le bachotage de dernière minute. Ces jalons valorisent la constance et la profondeur, les mêmes habitudes qui portent la semaine d’examen.",
    items: {
      first_finish: {
        title: "Première mission terminée",
        desc: "Terminez au moins une session complète de pratique ou d’examen sur cette filière.",
      },
      week_rhythm: {
        title: "Rythme de semaine",
        desc: "Pratiquez au moins 3 jours civils distincts (UTC) sur les 7 derniers jours.",
      },
      streak_3: {
        title: "Série de 3 jours",
        desc: "Enchaînez 3 jours civils consécutifs (UTC) avec des sessions terminées sur cette filière.",
      },
      century_correct: {
        title: "Club du siècle",
        desc: "Atteignez 100 bonnes réponses sur cette filière — la preuve que la banque vous fait progresser.",
      },
      five_hundred: {
        title: "Cinq cents solides",
        desc: "Atteignez 500 bonnes réponses sur cette filière — un volume sérieux vers la préparation d’examen.",
      },
      category_explorer: {
        title: "Explorateur de catégories",
        desc: "Touchez au moins 4 catégories avec 5+ réponses chacune — une préparation équilibrée.",
      },
      monthly_momentum: {
        title: "Élan du mois",
        desc: "Terminez 10 sessions sur cette filière dans les 30 derniers jours — un rythme soutenable.",
      },
      accuracy_ready: {
        title: "Seuil de justesse",
        desc: "Au moins 80 réponses avec ≥72 % de justesse globale sur cette filière — la qualité avant la vitesse.",
      },
    },
  },

  review: {
    examDebrief: "Compte Rendu d'Examen",
    debriefing: "Débriefing",
    errNotFound: "ERR : DONNÉES DE SESSION INTROUVABLES",
    pass: "RÉUSSI",
    fail: "ÉCHOUÉ",
    partialFail: "ÉCHEC\nPARTIEL",
    correctOutOf: "{n} correct(s) sur {total} questions (au total)",
    partialFailNoteOne: "Le score global est qualifié ({score}% ≥ {pass}%), mais la section {cat} n'a pas atteint le minimum requis de {pass}%. Chaque section doit être réussie.",
    partialFailNoteMany: "Le score global est qualifié ({score}% ≥ {pass}%), mais {n} sections n'ont pas atteint le minimum requis de {pass}%. Chaque section doit être réussie.",
    failNote: "Vous aviez besoin de {pass}% au total pour réussir. Vous avez obtenu {score}% — {short} point{s} en dessous.",
    failNoteOne: "Vous aviez besoin de {pass}% au total pour réussir. Vous avez obtenu {score}% — {short} point en dessous.",
    sectionBreakdown: "Résultats par Section",
    minRequired: "Minimum requis par section : {pass}%",
    flyAgain: "Revoler",
    goAround: "Remise des Gaz",
    newFlight: "Nouveau Vol",
    flightScore: "Score de Vol",
    yourCall: "Votre Réponse :",
    correctLabel: "Correct :",
    explanation: "EXPLICATION :",
    examReview: "Révision d'Examen",
    flightLog: "Journal de Vol",
    records: "ENREGISTREMENTS",
    practiceLabel100: "Approche Parfaite — Posé en Douceur",
    practiceLabel90: "Exceptionnel — Presque Sans Faute",
    practiceLabel80: "Bon Vol — Bonne Approche",
    practiceLabel70: "Dégagé — Serrez le Circuit",
    practiceLabelFail: "Remise des Gaz — Plus de Circuits Nécessaires",
    answeredCorrectly: "Vous avez répondu correctement à {n} questions sur {total} au total.",
    saveQuestion: "Sauver",
    savedQuestion: "Sauvé",
    unsaveQuestion: "Retirer",
  },

  scenarioTraining: {
    title: "Entraînement par Scénarios",
    subtitle: "Scénarios de vol CPL de style examen pour une pratique ciblée.",
    selectTier: "CHOISISSEZ VOTRE NIVEAU",
    selectTierSub: "Choisissez un niveau de difficulté pour commencer votre session de scénarios.",
    startSession: "DÉMARRER LA SESSION",
    question: "Question",
    of: "sur",
    score: "Score",
    correct: "Correct",
    incorrect: "Incorrect",
    next: "Question Suivante",
    sessionComplete: "SESSION TERMINÉE",
    accuracy: "Précision",
    restart: "Nouvelle Session",
    backToTiers: "Retour aux Niveaux",
    explanation: "Explication",
    ruleOfThumb: "Règle Pratique",
    scenarioContext: "Contexte du Scénario",
    proRequired: "Pro Plus Avancé Requis",
    proRequiredBody: "L'entraînement par scénarios est une fonctionnalité exclusive Pro Plus Avancé. Passez au niveau supérieur pour débloquer les sessions de type scénario.",
    upgradeBtn: "Passer au Pro Plus Avancé",
    loadingSession: "Chargement de votre session de scénarios...",
    noQuestionsTitle: "AUCUN SCÉNARIO DISPONIBLE",
    noQuestionsBody: "Aucune question de scénario n'est disponible pour ce niveau. Veuillez essayer un autre niveau.",
    tierStandard: "Standard",
    tierIntermediate: "Intermédiaire",
    tierAdvanced: "Avancé",
    tierExpert: "Expert",
    available: "disponible",
    noQuestionsYet: "Aucune question",
    aiDisclaimer: "Les questions de scénario sont rédigées et conservées par notre équipe. Elles peuvent différer en style de la banque principale rotative et n'apparaissent que dans ce mode d'entraînement.",
    proRequiredUpgrade: "Passez au niveau supérieur pour accéder à l'entraînement par scénarios.",
    seeResults: "Voir les résultats",
    outstanding: "Excellent !",
    goodWork: "Bon travail",
    keepPracticing: "Continuez à pratiquer",
    summaryAnsweredCorrectly: "Vous avez répondu correctement à {correct} sur {total} questions",
    totalLabel: "Total",
  },

  settings: {
    title: "Paramètres",
    tabs: {
      appearance: "Apparence",
      account: "Profil",
      security: "Sécurité",
      billing: "Facturation",
    },
    appearance: {
      title: "Apparence",
      themeLabel: "Thème",
      languageLabel: "Langue",
      languageDesc: "Choisissez la langue de l'interface.",
      fontSizeLabel: "Taille du texte",
      fontSizeDesc: "Ajustez la taille des questions et des menus sur votre appareil.",
      fontSizes: {
        xs: "Très petit",
        sm: "Petit",
        md: "Normal",
        lg: "Grand",
        xl: "Très grand",
      },
      fontStyleLabel: "Style de police",
      fontStyleDesc: "Par défaut du thème conserve les polices du thème. Les autres options les remplacent partout.",
      fontStyles: {
        theme: "Thème",
        modern: "Moderne",
        system: "Système",
        mono: "Monospace",
        serif: "Serif",
        classic: "Classique",
      },
      reduceMotionLabel: "Réduire les animations",
      reduceMotionDesc: "Moins de mouvement dans l'app — transitions plus calmes.",
      comfortableSessionLabel: "Mise en page spacieuse",
      comfortableSessionDesc: "Boutons de réponse plus grands et plus d'espace pendant les questions (pratique, session et révision).",
      sidebarClockLabel: "Horloge de la barre latérale",
      sidebarClockDesc: "Contrôle l'horloge affichée dans la barre latérale et l'en-tête mobile.",
      showSidebarClockLabel: "Afficher l'horloge",
      showSidebarClockDesc: "Désactiver pour masquer l'horloge dans la barre latérale et l'en-tête mobile.",
      localTimeLabel: "Heure locale",
      localTimeDesc: "Affiche le fuseau de votre appareil au lieu de l'UTC (Zulu).",
    },
    account: {
      title: "Compte",
      profileTitle: "Profil de Pilote",
      nicknameLabel: "Pseudo (classement)",
      nicknamePlaceholder: "ex. Skyhawk_42",
      nicknameHint: "Nom public sur le classement. 2 à 24 caractères : lettres, chiffres, espaces, tiret bas ou tiret. Pas de grossièretés ni de langage offensant. Laissez vide pour ne pas apparaître.",
      leaderboardOptInLabel: "M’afficher dans le classement",
      leaderboardOptInHint: "Désactivez pour masquer vos scores du classement public (votre pseudo n’apparaît pas lorsque c’est désactivé).",
      fullName: "Nom Complet",
      email: "Courriel",
      phone: "Téléphone",
      country: "Pays",
      pilotType: "Type de Pilote / Licence",
      ratings: "Qualifications & Mentions",
      saveProfile: "Enregistrer le Profil",
      saving: "Enregistrement...",
      saved: "Enregistré",
      securityTitle: "Sécurité",
      changePassword: "Changer le Mot de Passe",
      twoFaTitle: "Authentification à Deux Facteurs",
    },
    billing: {
      title: "Facturation",
      currentPlan: "Plan Actuel",
      manageSub: "Gérer l'Abonnement",
      cancelSub: "Annuler l'Abonnement",
      renewSub: "Renouveler l'Abonnement",
    },
    headerSub: "Gérer votre compte, l'apparence et l'abonnement",
    recovery: {
      title: "Codes de Récupération",
      hint: "Conservez ces codes en lieu sûr — gestionnaire de mots de passe, papier imprimé ou note sécurisée. Chaque code ne peut être utilisé qu'une seule fois. Ces codes ne seront plus affichés.",
      copyAll: "Tout copier",
      download: "Télécharger",
      savedCodes: "J'ai sauvegardé mes codes",
    },
  },

  contact: {
    title: "Tour de Contrôle",
    subtitle: "Soumettez un ticket de support, suivez vos conversations ou lisez les messages de l'équipe.",
    tabNew: "Nouveau Ticket",
    tabMine: "Mes Tickets",
    tabInbox: "Boîte de Réception",
    tabNewsletter: "Infolettre",
    formTitle: "Soumettre un Ticket de Support",
    formSubtitle: "Nous répondons généralement dans les 24 à 48 heures.",
    categoryLabel: "Catégorie",
    categoryPlaceholder: "Sélectionner une catégorie...",
    subjectLabel: "Sujet",
    subjectPlaceholder: "Bref résumé de votre problème ou question",
    messageLabel: "Message",
    messagePlaceholder: "Décrivez votre problème en détail. S'il s'agit d'une question de contenu, indiquez le numéro de question (affiché en Q# lors d'une session).",
    submitBtn: "SOUMETTRE LE TICKET",
    submitting: "EN COURS...",
    validationCategory: "Sélectionnez une catégorie",
    validationSubject: "Sujet trop court",
    validationMessage: "Message trop court (min 10 caractères)",
    successTitle: "TICKET SOUMIS",
    successBody: "Nous avons reçu votre message et vous répondrons dès que possible. Vous pouvez suivre la conversation dans Mes Tickets.",
    submitAnother: "Soumettre un Autre",
    viewMyTickets: "Voir Mes Tickets",
    noTickets: "Aucun ticket pour l'instant.",
    noArchived: "Aucun ticket archivé.",
    statusOpen: "OUVERT",
    statusInProgress: "EN COURS",
    statusResolved: "RÉSOLU",
    replyPlaceholder: "Tapez votre réponse...",
    sendReply: "Envoyer",
    sending: "Envoi...",
    archiveBtn: "Archiver",
    unarchiveBtn: "Désarchiver",
    deleteBtn: "Supprimer",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer ce ticket ?",
    cancel: "Annuler",
    noMessages: "Aucun message pour l'instant.",
    noNewsletters: "Aucune infolettre pour l'instant.",
    draft: "Brouillon",
    recipients: "destinataires",
    failedSubmit: "Échec de la soumission. Veuillez réessayer.",
    showArchived: "Afficher Archivés",
    hideArchived: "Masquer Archivés",
    threadOriginalMsg: "Votre message original",
    threadLoading: "Chargement de la conversation...",
    threadNoReplies: "Pas encore de réponse — nous vous répondrons bientôt.",
    threadReplyHint: "Ajouter des informations… (Ctrl+Entrée pour envoyer)",
    threadSending: "ENVOI...",
    threadSend: "ENVOYER",
    threadResolved: "Ce ticket est résolu. Soumettez un nouveau ticket si vous avez besoin d'aide supplémentaire.",
  },

  login: {
    tagline: "Préparez vos examens, maîtrisez les cieux",
    emailLabel: "Courriel",
    emailPlaceholder: "pilote@exemple.com",
    passwordLabel: "Mot de passe",
    forgotPassword: "Mot de passe oublié?",
    rememberMe: "Se souvenir de moi 30 jours",
    accountLocked: "Compte verrouillé",
    contactSupportUnlock: "Contacter le support pour déverrouiller",
    deviceInUse: "Appareil déjà utilisé",
    signingIn: "Connexion...",
    finalizingSignIn: "Finalisation de la connexion…",
    finalizingRetry: "Réessayer",
    finalizingBackToLogin: "Retour à la connexion",
    logIn: "Se connecter",
    noAccount: "Pas de compte?",
    signUp: "S'inscrire",
    privacy: "Confidentialité",
    terms: "Modalités",
    waiver: "Décharge",
    recoveryCodeTitle: "Code de Récupération",
    twoFaTitle: "Authentification à deux facteurs",
    emailVerification: "Vérification par courriel",
    authenticatorApp: "Application authentificateur",
    enterRecoveryHint: "Entrez un de vos codes de récupération sauvegardés.",
    enterEmailCodeHint: "Entrez le code à 6 chiffres envoyé à votre courriel.",
    enterAppCodeHint: "Entrez le code à 6 chiffres de votre application.",
    recoveryCodeLabel: "Code de récupération",
    verificationCodeLabel: "Code de vérification",
    verifying: "Vérification...",
    verify: "Vérifier",
    resendCode: "Renvoyer le code",
    useRecovery: "Utiliser un code de récupération",
    useAuthEmail: "Utiliser le code auth/courriel",
    backToLogin: "Retour à la connexion",
    orDivider: "ou",
    supportTitle: "Support",
    supportHint: "Des problèmes ? Envoyez-nous un message et nous vous aiderons.",
    supportFullName: "Nom complet *",
    supportPhone: "Téléphone",
    supportNamePlaceholder: "Marie Dupont",
    supportPhonePlaceholder: "+1 (555) 000-0000",
    supportEmailLabel: "Courriel *",
    supportEmailPlaceholder: "pilote@exemple.com",
    supportSubject: "Sujet *",
    supportSubjectPlaceholder: "Bref résumé...",
    supportMessage: "Message *",
    supportMessagePlaceholder: "Décrivez votre problème (20 caractères minimum)...",
    supportSending: "ENVOI...",
    supportSend: "ENVOYER",
    supportSentTitle: "MESSAGE ENVOYÉ",
    supportSentBody: "Nous avons reçu votre message et vous répondrons dans les plus brefs délais.",
    supportClose: "FERMER",
  },

  subscription: {
    backToDashboard: "← Tableau de bord",
    title: "CHOISISSEZ VOTRE TRAJECTOIRE",
    subtitle: "Un plan est pour la pratique. Un plan est pour réussir.",
    subtitle2: "Seul Pro Plus Avancé reproduit les vraies conditions d'examen de Transports Canada.",
    currentPlan: "PLAN ACTUEL :",
    monthly: "MENSUEL",
    annual: "ANNUEL",
    save20: "ÉCONOMISEZ 20 %",
    billedAnnually: "facturé annuellement",
    perMonth: "/mois",
    cancelAnytime: "par mois · annulez en tout temps",
    noCardNeeded: "Aucune carte requise · à vie",
    currentPlanBadge: "VOTRE PLAN ACTUEL",
    downgradePortal: "RÉTROGRADER VIA LE PORTAIL",
    includedIn: "INCLUS DANS PRO PLUS AVANCÉ",
    practiceOnly: "PRATIQUE SEULEMENT",
    practiceOnlyWarning: "Niveau pratique seulement. Insuffisant pour une préparation complète à l'examen. Un bassin de questions limité peut laisser des lacunes.",
    included: "Inclus",
    notIncluded: "Non inclus",
    manageSubscription: "GÉRER L'ABONNEMENT",
    loading: "CHARGEMENT...",
    examReadyScore: "Le Score de préparation vous indique exactement quand réserver votre examen Transports Canada.",
    passYourExam: "RÉUSSIR L'EXAMEN",
    startPracticing: "Commencer à pratiquer",
    examReady: "PRÊT POUR L'EXAMEN",
    proOnlyNote: "Une bonne façon de se familiariser avec les sujets d'examen à l'aide de ~400 questions dans les 4 sections. Convient pour les débuts. Non recommandé comme seul outil de préparation — le bassin de questions limité ne couvre pas la totalité des questions de l'examen réel.",
    proNote: "PRO — PRATIQUE SEULEMENT",
    proPlusNote: "PRO PLUS AVANCÉ — PRÉPARATION COMPLÈTE",
    proPlusDesc: "Le seul niveau conçu pour vous faire passer le vrai examen. Avec plus de 5 000 questions, des simulations CPAER chronométrées, un entraînement ciblé et un Score de préparation avec prédiction de réussite.",
    footer: "Paiements traités de façon sécurisée par Stripe. Annulez en tout temps via le portail de facturation.",
    manageBilling: "Gérer la facturation / annuler l'abonnement",
    designedToPass: "Conçu pour les étudiants qui veulent réussir du premier coup",
    proCompleteDesc: "Le système complet de préparation à l'examen CPL. Conçu pour reproduire les vraies conditions d'examen de Transports Canada — afin que vous vous présentez préparé, confiant et prêt à réussir du premier coup.",
    errorCheckout: "Impossible de démarrer le paiement. Veuillez réessayer.",
    errorPortal: "Impossible d'ouvrir le portail de facturation. Veuillez réessayer.",
    mostPopular: "LE PLUS POPULAIRE",
    platinumSelectPlan: "CHOISIR LE FORFAIT",
    platinumSelectThisPlan: "CHOISIR CE FORFAIT",
    platinumSubscribeProPlus: "S'ABONNER À PRO PLUS",
    platinumStarterLabel: "ESSENTIEL DE BASE (GRATUIT)",
    platinumCplPrepPro: "CPL PRÉP PRO",
    platinumProPlusTitle: "PRO PLUS AVANCÉ",
    platinumAdminPreview: "APERÇU ADMIN — page telle que la voit un utilisateur gratuit",
  },

  onboarding: {
    welcomeTitle: "Bienvenue à bord, {name} !",
    welcomeBody: "Flight Deck est votre copilote pour l'examen CPL. Plus de 5 000 questions, des modes de pratique ciblés et un Score de préparation qui vous dit exactement quand réserver. Laissez-nous vous guider.",
    skip: "Passer",
    letsGo: "Faites-moi visiter",
    back: "Retour",
    next: "Suivant",
    finish: "Encore une chose",

    step1Title: "Aperçu de mission",
    step1Body: "Votre tableau de bord est votre centre de contrôle. Consultez votre précision globale, les questions répondues, vos séries quotidiennes et une répartition complète par sujet dans les 4 domaines de l'examen CPL de Transports Canada.",

    step2Title: "Demande de décollage",
    step2Body: "Plus de 5 000 questions dans 4 domaines. Percez par catégorie, utilisez Grimper l'échelle pour un rythme du plus facile au plus difficile dans une matière, en mode aléatoire ou en simulation CPAER chronométrée. Chaque réponse inclut une explication complète avec références aux RAC — pour comprendre le 'pourquoi', pas juste la bonne lettre.",

    step3Title: "Entraînement par scénarios",
    step3Body: "Pratiquez des questions de scénario de style examen qui combinent plusieurs sujets à la fois — comme à l'examen réel. Ce mode aide à renforcer le jugement, les calculs et la prise de décision sous pression.",
    step3Badge: "NOUVEAU",

    step4Title: "Zones de turbulence",
    step4Body: "Le système enregistre chaque mauvaise réponse et identifie automatiquement vos catégories les plus faibles. Les exercices ciblés se concentrent sur vos lacunes — aucun temps perdu à revoir ce que vous savez déjà. La plupart des étudiants améliorent leur catégorie la plus faible de 30 %+ en une semaine.",

    step5Title: "Journal de bord",
    step5Body: "Votre Score de préparation à l'examen est calculé à partir des tendances de précision, de la diversité des questions et de la constance dans le temps. Quand il se maintient au-dessus de 80 %, vous êtes statistiquement prêt à passer l'examen écrit de Transports Canada.",

    step6Title: "Personnalisez votre cockpit",
    step6Body: "Passez de l'anglais au français à tout moment, choisissez un thème visuel adapté à votre style d'étude, activez l'authentification à deux facteurs pour la sécurité du compte et gérez votre facturation depuis un seul endroit. Votre cockpit, vos règles.",

    step7Title: "Carte rapide de navigation",
    step7Body: "Utilisez Poste de Pilotage comme vue principale, Demander le Décollage pour lancer des sessions, Zones de Turbulence pour corriger vos erreurs, Tour pour le support, et Paramètres pour le profil + la sécurité. En cas de doute, revenez d'abord au Poste de Pilotage.",

    step8Title: "Comment fonctionne le classement",
    step8Body: "Ouvrez Paramètres > Profil, définissez un pseudo et laissez la visibilité du classement activée. Ensuite utilisez le bouton Classement sur le Poste de Pilotage. Votre position reflète vos résultats réels sur la fenêtre choisie—bonnes réponses, erreurs et justesse—pas un score artificiel. Seuls les pseudos sont publics.",

    step9Title: "Guide rapide des boutons",
    step9Body: "Les boutons principaux (pleins) font avancer l'action : démarrer des sessions, soumettre des réponses et continuer. Les boutons contour ouvrent des outils comme Classement et Historique des sessions. En cas d'hésitation, lisez le court texte d'aide sous chaque section avant d'appuyer.",

    finalTitle: "Autorisé au décollage — Obtenons votre certification",
    finalSubtitle: "Tout ce qu'il vous faut pour réussir votre examen écrit CPL du premier coup.",
    finalWhatsIncluded: "Ce qui est inclus dans Pro Plus Avancé",
    upsell1: "Plus de 5 000 questions rotatives dans les 4 domaines de l'examen CPL",
    upsell2: "Pratique par scénarios de style examen pour renforcer vos points faibles dans le temps",
    upsell3: "Simulations CPAER chronométrées avec prédiction de réussite",
    upsell4: "Score de préparation à l'examen — sachez exactement quand réserver votre examen Transports Canada",
    upsell5: "Détection automatique des faiblesses avec moteur d'exercices ciblés",
    upgradeNow: "Passer à Pro Plus Avancé",
    startPracticing: "Commencer à pratiquer d'abord",
    goToDashboard: "Pas maintenant — aller au tableau de bord",
    neverShow: "Ne plus afficher",
  },

  resetPassword: {
    subtitle: "RÉINITIALISATION DU MOT DE PASSE",
    invalidLink: "Lien de réinitialisation invalide. Veuillez en demander un nouveau.",
    backToLogin: "Retour à la Connexion",
    newPasswordLabel: "NOUVEAU MOT DE PASSE",
    confirmPasswordLabel: "CONFIRMER LE MOT DE PASSE",
    hint: "Min 8 caractères • Majuscules et minuscules • Caractère spécial • Pas de séquence longue",
    missingToken: "Jeton de réinitialisation manquant. Veuillez utiliser le lien reçu par courriel.",
    passwordMismatch: "Les mots de passe ne correspondent pas",
    saving: "Enregistrement...",
    submit: "DÉFINIR LE NOUVEAU MOT DE PASSE",
    successTitle: "MOT DE PASSE MIS À JOUR",
    successBody: "Redirection vers la connexion...",
    resetFailed: "Échec de la réinitialisation",
  },

  adminPublicContacts: {
    title: "Contacts Pré-Connexion",
    subtitle: "Messages d'assistance soumis depuis la page de connexion publique avant de se connecter.",
    markAllSeen: "Tout marquer comme vu",
    noContacts: "Aucun contact pré-connexion pour l'instant.",
    colDate: "Date",
    colName: "Nom / Courriel",
    colPhone: "Téléphone",
    colSubject: "Sujet",
    colMessage: "Message",
    colIP: "IP",
    colStatus: "Statut",
    statusNew: "NOUVEAU",
    statusSeen: "Vu",
    markSeen: "Marquer comme vu",
    loadingError: "Erreur lors du chargement des contacts.",
    markAllDone: "Tous les contacts marqués comme vus.",
    expandMsg: "Afficher le message complet",
    collapseMsg: "Réduire",
  },

  common: {
    loading: "Chargement...",
    error: "Une erreur s'est produite. Veuillez réessayer.",
    cancel: "Annuler",
    save: "Enregistrer",
    close: "Fermer",
    upgrade: "Mettre à niveau",
    learnMore: "En savoir plus",
    backToDashboard: "Retour au Tableau de Bord",
    notFound: "Page introuvable",
    accuracy: "Précision",
    noData: "Aucune donnée disponible",
  },
};
